import { render } from "./approval.vue?vue&type=template&id=4f8c50cc"
import script from "./approval.vue?vue&type=script&lang=js"
export * from "./approval.vue?vue&type=script&lang=js"

import exportComponent from "D:\\xampp\\htdocs\\software.icarusbd.com\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__